import * as React from 'react';
import {Link} from 'react-router-dom';
// @ts-expect-error
import type {LocationShape} from 'react-router-dom';

import classnames from 'classnames';

import {ActionMenu} from '../action-menu/action-menu';
import {FlashBanner} from '../flash-banner/flash-banner';

import styles from './list-row.module.css';

type Props = {
    options: any[];
    style?: any;
    onClick?: (e: React.SyntheticEvent) => void;
    to?: LocationShape;
    isSelected?: boolean;
    hasBorders?: boolean;
    hideActionMenu?: boolean;
    errorMessage?: string;
    onClearError?: () => any;
    onOpenActionMenu?: () => any;
    children?: React.ReactNode;
    anchorElementId?: string;
};

export class ListRow extends React.Component<Props> {
    static defaultProps = {
        options: [],
    };

    render() {
        const styleNames = classnames(styles.container, {
            [styles['container-selected']]: this.props.isSelected,
            [styles['container-bordered']]: this.props.hasBorders,
            [styles['container-clickable']]: this.props.to || this.props.onClick,
        });

        const Tag = this.props.to ? Link : 'div';

        return (
            // @ts-expect-error
            <Tag
                style={this.props.style}
                to={this.props.to}
                onClick={this.props.onClick}
                className={styleNames}
            >
                <div className={styles['border-container']}>
                    <div className={styles['left-column']}>{this.props.children}</div>
                    <div className={styles['right-column']}>
                        {this.props.options.length && !this.props.hideActionMenu ? (
                            <div className={styles['action-menu-container']}>
                                <ActionMenu
                                    options={this.props.options}
                                    onClick={this.props.onOpenActionMenu}
                                    callMountId={this.props.anchorElementId}
                                />
                            </div>
                        ) : (
                            this.renderEmptyActionMenu()
                        )}
                    </div>
                </div>
                {this.props.errorMessage ? (
                    <div className={styles.error}>
                        <FlashBanner onHidden={this.props.onClearError} type='error'>
                            <div>{this.props.errorMessage}</div>
                        </FlashBanner>
                    </div>
                ) : undefined}
            </Tag>
        );
    }

    renderEmptyActionMenu() {
        return this.props.hideActionMenu ? undefined : (
            <div className={styles['action-menu-container']} />
        );
    }
}
